<template>
  <div class="search-question-header-container">
    <ValidationObserver ref="form">
      <CRow>
        <CCol md="3" sm="12">
          <ValidationProvider name="SEARCH_QUESTION_HEADER_COMPONENT_KEYWORD_FIELD_NAME" v-slot="{ errors }" rules="max:100">
            <CInput
              :label="$t('SEARCH_QUESTION_HEADER_COMPONENT_KEYWORD_FIELD_NAME')"
              type="text"
              v-model="searchData.keyword"
              class="form-group"
              @keyup.enter="search()"
            />
            <CRow>
              <CCol :md="12">
                <span class="error-msg-wrap">
                  <span class="error-msg">{{ errors[0] }}</span>
                </span>
              </CCol>
            </CRow>
          </ValidationProvider>
        </CCol>

        <CCol md="3" sm="12">
          <div role="group" class="form-group form-group">
            <label class>{{ $t('SEARCH_QUESTION_HEADER_COMPONENT_CATEGORY_LABEL') }}</label>
            <select v-model="searchData.category_type" class="form-control">
              <option value>{{ $t('SEARCH_QUESTION_HEADER_COMPONENT_ALL_CATEGORY_LABEL') }}</option>
              <option v-for="item in questionCatList" :key="item.value" :value="item.value">{{ item.label }}</option>
            </select>
          </div>
        </CCol>

        <CCol md="3" sm="12">
          <div role="group" class="form-group form-group">
            <label class>{{ $t('SEARCH_QUESTION_HEADER_COMPONENT_TYPE_LABEL') }}</label>
            <select v-model="searchData.question_type" class="form-control">
              <option value>{{ $t('SEARCH_QUESTION_HEADER_COMPONENT_ALL_TYPE_LABEL') }}</option>
              <option v-for="item in questionTypeList" :key="item.value" :value="item.value">{{ item.label }}</option>
            </select>
          </div>
        </CCol>
      </CRow>
    </ValidationObserver>

    <CRow class="mt-2 form-actions">
      <div class="col-md-6 btn-disabled"></div>
      <CCol md="3" sm="12">
        <CButton class="btn btn-reset" @click="resetForm()">{{ $t('SEARCH_QUESTION_HEADER_COMPONENT_RESET_BUTTON') }}</CButton>
      </CCol>

      <CCol md="3" sm="12">
        <CButton class="btn btn-search" @click="search()">{{ $t('SEARCH_QUESTION_HEADER_COMPONENT_SEARCH_BUTTON') }}</CButton>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import moment from 'moment';
import { Constants } from '@/constants';
import stringHelper from '@/utils/string-helper';
import sessionStorageHelper from '@/utils/sessionStorage-helper';
import dateTimeHelper from '@/utils/datetime-helper';

export default {
  name: 'SearchQuestionHeader',
  components: {},
  data() {
    return {
      searchData: sessionStorageHelper.getData(sessionStorageHelper.KEYS.FilterQuestions) || this.getDefaultValues(),
    };
  },
  props: {
    onSearch: {
      type: Function,
      default: null,
    },
    questionTypeList: {
      type: Array,
      default: () => [],
    },
    questionCatList: {
      type: Array,
      default: () => [],
    },
  },
  async mounted() {
    this.search();
  },
  methods: {
    getDefaultValues() {
      return {
        keyword: '',
        question_type: '',
        category_type: '',
      };
    },
    resetForm() {
      this.searchData = this.getDefaultValues();

      this.search();
    },
    async search() {
      const isValid = await this.$refs.form.validate();
      if (!isValid) {
        return;
      }

      sessionStorageHelper.setData(sessionStorageHelper.KEYS.FilterQuestions, this.searchData);

      const searchData = {
        ...this.searchData,
      };
      this.onSearch(searchData);
    },
  },
};
</script>>

<style lang="scss">
.search-question-header-container {
  margin-bottom: 35px;
  .form-search {
    margin-bottom: 5px;
  }

  .form-actions {
    .btn {
      border: none;
      border-radius: 32px;
      height: 32px;
      padding: 0 30px;
      color: #fff;
      font-size: 14px;
      letter-spacing: 0;
      line-height: 14px;
      text-align: center;
      border: 1px solid #1a2958;
      border-radius: 17.5px;
      background-color: #1a2958;
      width: 100%;
      display: block;

      &.btn-search {
        background: #3b4b7e;
      }

      &.btn-reset,
      &.btn-download-csv {
        color: #1a2958;
        background-color: #fff;
      }
    }
  }
}
</style>
